"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const md_utils_1 = require("../../../export/md.utils");
const toMarkdown = (element, context) => {
    var _a;
    if (!((_a = element.value) === null || _a === void 0 ? void 0 : _a.items) || element.value.items.length === 0) {
        return '';
    }
    const sections = [];
    sections.push('**Grouping Exercise**\n');
    element.value.items.forEach((group, groupIndex) => {
        var _a, _b;
        const groupParts = [];
        if ((_a = group.target) === null || _a === void 0 ? void 0 : _a.label) {
            groupParts.push(`**Group ${groupIndex + 1}: ${group.target.label}**`);
        }
        if ((_b = group.target) === null || _b === void 0 ? void 0 : _b.image) {
            const url = (0, md_utils_1.getFileUrl)(group.target.image, context);
            if (url) {
                groupParts.push(`![Group Image](${url})`);
            }
        }
        if (group.items && group.items.length > 0) {
            groupParts.push('Items:');
            group.items.forEach((item) => {
                const itemParts = [];
                if (item.label) {
                    itemParts.push(`- ${item.label}`);
                }
                if (item.image) {
                    const url = (0, md_utils_1.getFileUrl)(item.image, context);
                    if (url) {
                        itemParts.push(`  ![Item Image](${url})`);
                    }
                }
                if (itemParts.length > 0) {
                    groupParts.push(itemParts.join('\n'));
                }
            });
        }
        if (groupParts.length > 0) {
            sections.push(groupParts.join('\n'));
        }
    });
    if (sections.length === 1) {
        return '';
    }
    return sections.join('\n\n') + '\n\n';
};
exports.toMarkdown = toMarkdown;
